import postcastLogo from 'Assets/postcast-logo.png';
import { useNavigate } from "react-router";

import "./UnauthedHeader.css";

const UnauthedHeader = (props) => {
  const { page } = props;
  const navigate = useNavigate();

  const className = 'unauthed-header-menu-bar-item-container';
  return (
    <div className="unauthed-header-container">
      <img src={postcastLogo} style={{ width: 45, height: 45 }} onClick={() => navigate("/")} />
      <div className="unauthed-header-title-text" onClick={() => navigate("/")}>
        Postcast
      </div>
      <div className="unauthed-header-menu-bar-container">
        <div
          className={`${className} ${page === 'about' ? 'selected' : ''}`}
          onClick={() => navigate("/about")}
        >
          About
        </div>
        <div
          className={`${className} ${page === 'pricing' ? 'selected' : ''}`}
          onClick={() => navigate("/pricing")}
        >
          Pricing
        </div>
        <div
          className={`${className} ${page === 'contact' ? 'selected' : ''}`}
          onClick={() => navigate("/contact")}
        >
          Contact Us
        </div>
        <div
          className={`${className} ${page === 'login' ? 'selected' : ''}`}
          onClick={() => navigate("/login")}
        >
          Login
        </div>
      </div>
    </div>
  );
};

export default UnauthedHeader;
